<template>
  <div class="index-content">
    <div class="container">
      <div class="card bg-secondary">
        <img
        src="@/assets/img/family.svg?data"
        alt="En familj"
        class="img-fluid img-cntr"
        />
        <div class="card-body">
          <h1 class="h3 mb-3 font-weight-normal text-light"><strong>FH</strong>abian</h1>
          <hr />
          <div class="clearfix"></div>
          <br />
          <p class="text-light">
            För att få åtkomst till gränssnittet så behöver du ha tillgång till ditt SITHS-kort.
          </p>
          <p class="text-light">
            När du är förberedd, kortläsaren inkopplad med tillhörande kort så logga in med knappen nedan.
          </p>
          <div class="clearfix"></div>
          <br />
          <button
          class="btn btn-lg btn-primary"
          type="button"
          @click="loginWithSiths()"
          @keyup.enter="loginWithSiths()"
          :disabled="isDev || isQa">
            <img src="@/assets/img/siths.png" alt="Ikon för SITHS-kort" class="img-fluid siths-icon" />
            Logga in med SITHS-kort
          </button>
          <div v-if="isDev || isQa">
            <!-- Sebbe test SITHS-login -->
            <div class="clearfix--min"></div>
            <button
              class="btn btn-md btn-block btn-info"
              type="button"
              @click="clearStorages()"
              v-if="$route.query.fakelogin === 'true'">
              Rensa local- och sessionStorage
            </button>
            <div class="clearfix--min"></div>
            <button
              class="btn btn-md btn-block btn-warning"
              type="button"
              @click="loginWithSithsDev()"
              @keyup.enter="loginWithSithsDev()"
              v-if="$route.query.fakelogin === 'true'">
                <img src="@/assets/img/siths.png" alt="Ikon för SITHS-kort" class="img-fluid siths-icon" />
                Logga in med SITHS-kort (dev)
            </button>
            <div class="clearfix--min"></div>
            <button
              class="btn btn-lg btn-block btn-dark"
              type="button"
              @click="setFakeLoginQueryParam()"
              v-if="$route.query.fakelogin !== 'true'"
            >?fakelogin=true</button>
            <button class="btn btn-md btn-block btn-danger" type="button"
             @click="fakeLoginOne()" v-if="$route.query.fakelogin === 'true'">
              <img src="@/assets/img/siths.png" alt="Ikon för SITHS-kort" class="img-fluid siths-icon" />
              Logga in som Kalle Karlsson
            </button>
            <div class="clearfix--min"></div>
            <button class="btn btn-md btn-block btn-danger" type="button"
             @click="fakeLoginTwo()" v-if="$route.query.fakelogin === 'true'">
              <img src="@/assets/img/siths.png" alt="Ikon för SITHS-kort" class="img-fluid siths-icon" />
              Logga in som Hedvig Hedvigsson
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="alert" class="alert alert-primary alert-bottom-right">
      <strong id="alert-txt"></strong>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { parseJwt } from '../plugins/jwtparser'

export default {
  name: 'index',
  components: {
  },
  data () {
    return {
      pnr: null,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {
    loginWithSiths () {
      let loader = this.$loading.show()
      const callbackUrl = window.location.origin.concat(config.callbackUri)
      const base64 = true
      axios.postLogin(config.loginUri, base64, callbackUrl).then((response) => {
        if (response) {
          loader.hide()
          localStorage.removeItem('dev')
          localStorage.setItem('isClinician', 'true')
          window.location.href = response.data.redirectUrl
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    loginWithSithsDev () {
      let loader = this.$loading.show()
      const callbackUrl = window.location.origin.concat(config.callbackUri)
      const base64 = true
      axios.postLogin(config.loginUri, base64, callbackUrl).then((response) => {
        if (response) {
          loader.hide()
          localStorage.removeItem('dev')
          localStorage.setItem('isClinician', 'true')
          localStorage.setItem('sithsDev', 'true')
          window.location.href = response.data.redirectUrl
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    setFakeLoginQueryParam () {
      window.history.replaceState(null, null, window.location.pathname)
      const urlParams = new URLSearchParams(window.location.search)
      urlParams.set('fakelogin', 'true')
      window.location.search = urlParams
    },
    clearStorages () {
      localStorage.clear()
      sessionStorage.clear()
      this.showAlert('Storages rensade!', 2000)
    },
    showAlert (txt, dur) {
      document.getElementById('alert').style.display = 'block'
      document.getElementById('alert-txt').innerHTML = txt
      setTimeout(() => { document.getElementById('alert').style.display = 'none' }, dur)
    },
    fakeLoginOne () {
      if (this.isDev || this.isQa) {
        let loader = this.$loading.show()
        const obj = {
          sessionId: '',
          givenName: 'Kalle',
          surName: 'Karlsson',
          hsaId: 'SE2321000016-1111', // Karolinska
          ssn: '123456798901'
        }
        axios.postTokenTest(config.tokenTestUri, obj).then((response) => {
          if (response) {
            loader.hide()
            localStorage.setItem('jwt', response.data)
            const decodedJwt = parseJwt(response.data)
            localStorage.setItem('isClinician', 'true')
            localStorage.setItem('clinicianId', decodedJwt.clinicianId)
            localStorage.setItem('clinicName', decodedJwt.clinicName)
            localStorage.setItem('hsaId', decodedJwt.hsaId)
            localStorage.setItem('fullname', decodedJwt.givenName + ' ' + decodedJwt.surName)
            this.$root.$emit('setName', decodedJwt.givenName + ' ' + decodedJwt.surName)
            window.location.href = window.location.origin.concat(config.callbackUri)
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    },
    fakeLoginTwo () {
      if (this.isDev || this.isQa) {
        let loader = this.$loading.show()
        const obj = {
          sessionId: '',
          givenName: 'Hedvig',
          surName: 'Hedvigsson',
          hsaId: 'SE5565189692-2222', // St Göran
          ssn: '987654321012'
        }
        axios.postTokenTest(config.tokenTestUri, obj).then((response) => {
          if (response) {
            loader.hide()
            localStorage.setItem('jwt', response.data)
            const decodedJwt = parseJwt(response.data)
            localStorage.setItem('isClinician', 'true')
            localStorage.setItem('clinicianId', decodedJwt.clinicianId)
            localStorage.setItem('clinicName', decodedJwt.clinicName)
            localStorage.setItem('hsaId', decodedJwt.hsaId)
            localStorage.setItem('fullname', decodedJwt.givenName + ' ' + decodedJwt.surName)
            this.$root.$emit('setName', decodedJwt.givenName + ' ' + decodedJwt.surName)
            window.location.href = window.location.origin.concat(config.callbackUri)
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label {
  color: #fff;
}
button:disabled {
  opacity: 0.3;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.container {
  padding-top: 0 !important;
}
.img-cntr {
  margin-left: auto;
  margin-right: auto;
  padding: 2rem 1rem 0rem 1rem;
}
.index-content {
  margin-top: 7.5%;
}
.pointer {
  cursor: pointer;
}
.siths-icon {
  width: 1.5vw;
  height: 1.5vw;
}
.card {
  height: auto;
  width: 35vw;
  margin-left: 1vw;
  margin-top: -3vh;
  border: 20px solid black;
}
.card p {
  text-align: center !important;
}
.card-header {
  padding: 50px;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .siths-icon {
    width: 5.5vw;
    height: 5.5vw;
  }
  .card {
    margin-top: 8vh;
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue